import angular from 'angular'

import component from './user-card.component'

let module = angular.module('userCardModule', [])

.component('userCard', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/components/user-card/index.js